import React from "react";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import useRudderStackAnalytics from "../../config/useRudderAnalytics";
import { useNavigate, useParams } from "react-router-dom";
import { getListWhs, resetWhsState } from "../../reducers/whsReducer";
export default function WHSListwhs(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const dispatch=useDispatch();    
    const driverId=useSelector(state=>state.driver.entities.currDriver?.driverId)
    const navigate=useNavigate();
    const {id}=useParams();
    const driverJobTitle=useSelector(state=>state.driver.entities.currDriver?.driverJobTitle);
    const handleToggle=(event)=>{
        navigate("/"+id+"/whs/report/"+event.currentTarget.value)
    }
    const whsList=useSelector(state=>state.whs.entities.whsList);
    const whsListElement=whsList && whsList.length>0?[...whsList].sort((a,b)=>new Date(b.date)-new Date(a.date)).map((e,id)=><Button onClick={handleToggle} key={id} value={e.date} variant="contained" className="listReport">{e.vehicle+" || "+dayjs(e.date).format("DD/MM/YYYY HH:mm A")}</Button>):<h3 style={{textAlign:"center"}}>You don't have any Vehicle Inspection report available right now.</h3>
    React.useEffect(()=>{
        if(driverJobTitle && !driverJobTitle.toLowerCase().includes("contractor")){
            dispatch(resetWhsState())
            dispatch(getListWhs({driverId:id}))
        }
    },[driverJobTitle, dispatch, id])
        React.useEffect(()=>{
            if(useRudderAnalytics && driverId){
                useRudderAnalytics.page("List Vehicle Inspect")
            }
        },[useRudderAnalytics, driverId])
    return (
        <>
            <div style={{display:"flex", justifyContent:"center", alignItems:"center", gap:"10px", flexDirection:"column", height:"100%", overflow:"hidden", paddingBottom:"20px"}}>
               {whsListElement}
            </div>
        </>
    )
}